<template>
  <div class="container">
    <a-drawer
      placement="right"
      :closable="false"
      :width="1200"
      :visible="detailVisible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
    >
      <!-- 头部固定内容 -->
      <div
        :style="{
          position: 'absolute',
          right: 0,
          top: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'left',
          zIndex: 99,
        }"
      >
        <div class="containerTop">费用详情</div>
        <div class="containerBottom">
          <div class="left">
            <div class="title">{{ detailData.tltle }}</div>
            <div style="margin-top: 10px">
              <span>{{ detailData.companyName }}公司/部门{{ detailData.deptName }}</span>
              <span v-if="detailData.BaseInformation.isFeeDept" style="font-weight: 700;color: black;margin-left: 20px">费用归属公司/部门: <span style="font-weight: 400;margin-left: 5px">{{detailData.relateDept}}</span></span>
              <span style="font-weight: 700; color: black; margin-left: 20px"
                >申请编号：{{ detailData.applyCode }}</span
              >
            </div>
          </div>
          <div class="right">
            <!-- 2222
                      <img src="" alt=""> -->
          </div>
        </div>
      </div>
      <!-- 中间详情区域 -->
      <div class="center">
        <!-- 基础信息区域 -->
        <div class="centerInform">
          <div class="title">
            <span>基础信息</span>
          </div>
          <div class="content">
            <div class="contentTop">
              <div class="left">付款类别</div>
              <div class="right">{{ detailData.BaseInformation.type }}</div>
            </div>
            <!-- <div class="top">备注说明</div>
            <div class="bottom">{{ detailData.BaseInformation.remark }}</div> -->
          </div>
        </div>
        <!-- 项目信息区域 -->
        <div>
          <div class="box" v-if="detailData.BaseInformation.isCheckInformation || detailData.BaseInformation.isReceived">
            <div class="title">
              <span>关联项目信息</span>
            </div>
            <div class="centerBox">
              <a-table :data-source="detailData.BaseInformation.information_relate" bordered :pagination="false">
                <a-table-column key="project_name" title="项目名称" data-index="project_name" style="color: red" />
                <a-table-column key="project_code" title="项目编号" data-index="project_code" />
                <a-table-column key="projece_pay" title="项目金额（元）*" data-index="projece_pay" />
                <a-table-column key="amount" :title="detailData.BaseInformation.isCheckInformation? '已付金额':'项目已回款（元）'" data-index="amount" />
                <a-table-column key="projece_fee" title="报销费用（元）" data-index="projece_fee" v-if="detailData.BaseInformation.isFindProject"/>
              </a-table>
            </div>
          </div>
        </div>
        <!-- 费用金额 -->
        <div class="box" v-if="detailData.detail">
          <div class="expensesTitle">
            <div class="title">
            <span>费用金额</span>
          </div>
          <div>
            <a-icon type="info-circle" />
           本次付款总金额：<span>{{detailData.projectMoney}}</span>元整
        </div>
          </div>
          <div class="centerBox">
            <div v-for="(item, index) in detailData.detail" :key="index" class="detail">
              <div class="top">
                  <a-divider orientation="left">
                    <span style="font-weight: 700;">费用明细{{ index + 1 }}</span>
                  </a-divider>
                
              </div>
              <div class="bottom">
                <div v-for="(item1, index1) in item" :key="index1">
                  <!-- <div>{{item1}}</div> -->
                  <div v-if="item1" style="font-weight: 700; margin: 7px">{{ item1.label }}</div>
                 <!-- 差旅费 -->
                   <div v-if="item1" style="margin: 5px">
                        <div v-if="item1.type == 'array'">
                            <div class="travelBoxTop">
                              <div  style="width: 45%; border-right: 1px solid #dedfdf;">
                                  <div class="travelContetTop">出差起始地</div>
                                  <div class="travelContetBottom">
                                       <span>{{item1.travelData.location_start}} ~ {{item1.travelData.location_end}}</span>
                                  </div>
                              </div>
                              <div  style="width: 15%; border-right: 1px solid #dedfdf;">
                                  <div class="travelContetTop">天数</div>
                                  <div class="travelContetBottom">
                                    <span>{{item1.travelData.days}}</span>
                                  </div>
                              </div>
                              <div  style="width: 40%;">
                                  <div class="travelContetTop">起止日期</div>
                                  <div class="travelContetBottom">
                                    <span>{{item1.travelData.time_start}} ~ {{item1.travelData.time_end}}</span>
                                  </div>
                              </div>
                            </div>
                            <div class="travelBoxCenter borderStyle borderBottom">
                                <div style="width: 50%; border-right: 1px solid #dedfdf; ">
                                    <div class="travelContetTop">异地交通费</div>
                                  <div class="layoutbox">
                                        <div style="width: 33.3%;">
                                            <div class="travelContetTop ">飞机</div>
                                            <div  class="travelContetBottom">
                                              <span>{{item1.travelData.plane_fee}}</span>
                                            </div>
                                        </div>
                                        <div style="width: 33.3%;">
                                            <div class="travelContetTop borderStyle">火车</div>
                                            <div  class="travelContetBottom borderStyle">
                                              <span>{{item1.travelData.train_fee}}</span>
                                            </div>
                                        </div>
                                        <div style="width: 33.4%;">
                                            <div class="travelContetTop">大巴</div>
                                            <div  class="travelContetBottom">
                                              <span>{{item1.travelData.bus_fee}}</span>
                                            </div>
                                        </div>
                                  </div>
                                </div>
                                <div style="width: 50%; ">
                                    <div class="travelContetTop">同城交通费</div>
                                    <div class="layoutbox">
                                        <div style="width: 33.3%;">
                                        <div class="travelContetTop ">地铁</div>
                                        <div  class="travelContetBottom">
                                          <span>{{item1.travelData.subway_fee}}</span>
                                        </div>
                                    </div>
                                    <div style="width: 33.3%;">
                                        <div class="travelContetTop borderStyle">公交</div>
                                        <div  class="travelContetBottom borderStyle">
                                          <span>{{item1.travelData.transit_fee}}</span>
                                        </div>
                                    </div>
                                    <div style="width: 33.4%;">
                                        <div class="travelContetTop">出租</div>
                                        <div  class="travelContetBottom">
                                          <span>{{item1.travelData.taxi_fee}}</span>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class="travelCenter borderStyle borderBottom">
                                <div class="contener">住宿费</div>
                                <div class="travelContetBottom contenerBox">
                                  <span>{{item1.travelData.live_fee}}</span>
                                </div>
                                <div class="contener">出差补贴</div>
                                <div class="travelContetBottom">
                                  <span>{{item1.travelData.travel_fee}}</span>
                                </div>
                            </div>
                            <div class="travelCenter borderStyle borderBottom">
                                <div class="contener">其他费用</div>
                                <div class="travelContetBottom contenerBox">
                                  <span>{{item1.travelData.other_fee}}</span>
                                </div>
                                 <div class="contener">小计（元）</div>
                                <div class="travelContetBottom">
                                  <span>{{item1.travelData.total}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else style="padding: 10px 5px">{{ item1.value }}</div>

                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <!-- 发票信息 -->
        <div class="box" v-if="detailData.BaseInformation.isCheckBill">
          <div class="title">
            <span>发票信息</span>
          </div>
          <div class="centerBox">
            <a-table
              :data-source="detailData.BaseInformation.bill_information"
              ref="bodyTop"
              :pagination="false"
              bordered
              :loading="loading"
              @change="handleTableChange"
            >
              <a-table-column key="bill_code" data-index="bill_code" title="发票代码" />
              <a-table-column key="bill_number" data-index="bill_number" title="发票号码" />
              <a-table-column key="bill_money" data-index="bill_money" title="发票金额(元)" />
              <a-table-column key="bill_date" data-index="bill_date" title="开票日期" />
              <a-table-column key="bill_type" title="发票类型" data-index="bill_type" />
              <a-table-column key="action" title="操作">
                <template slot-scope="text, record, index">
                  <span>
                    <a @click="downFile(index)">下载</a>
                  </span>
                </template>
              </a-table-column>
            </a-table>
          </div>
        </div>
        <!-- 关联审批信息 -->
        <div
          class="box"
          v-if="
            detailData.BaseInformation.isRelationAudit == true || detailData.BaseInformation.isRelationPurchase == true
          "
        >
          <div class="title">
            <span>关联审批信息</span>
          </div>
          <div class="centerBox">
            <a-table
              :data-source="detailData.BaseInformation.approvalData"
              ref="approvalDataRef"
              :pagination="false"
              bordered
              :loading="loading"
              @change="handleTableChange"
              v-if="detailData.BaseInformation.isRelationAudit"
            >
              <a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
              <a-table-column key="title" title="申请标题" data-index="title" />
              <a-table-column key="applyer" title="申请人" data-index="applyer" />
              <a-table-column key="applyTime" title="申请时间" data-index="applyTime" />
              <a-table-column key="result" title="审批结果" data-index="result">
                <template scope="text,record">
                  <a-tag :color="result_apply[record.result].color">
                    {{ result_apply[record.result].txt }}
                  </a-tag>
                </template>
              </a-table-column>
            </a-table>
            <a-table
              :data-source="detailData.BaseInformation.purchaseData"
              ref="receiptDataRef"
              :pagination="false"
              bordered
              :loading="loading"
              @change="handleTableChange"
              v-if="detailData.BaseInformation.isRelationPurchase == true"
            >
              <a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
              <a-table-column key="name" title="物品名称" data-index="name" />
              <a-table-column key="model" title="规格型号" data-index="model" />
              <a-table-column key="amount" title="数量" data-index="amount" />
              <a-table-column key="unit" title="单位" data-index="unit" />
              <a-table-column key="isInvalid" title="申购状态" data-index="isInvalid">
                <template scope="text,record">
                  <a-tag class="span" :color="record.isInvalid == 1 ? 'red' : 'green'">
                    {{ record.isInvalid == 1 ? '作废' : '正常' }}
                  </a-tag>
                </template>
              </a-table-column>
              <a-table-column key="result" title="审批结果" data-index="result">
                <template scope="text,record">
                  <a-tag :color="result_apply[record.result].color">
                    {{ result_apply[record.result].txt }}
                  </a-tag>
                </template>
              </a-table-column>
            </a-table>
          </div>
        </div>
          <!-- 备注信息 -->
        <div class="box">
              <div class="title">
                  <span>申请备注信息</span>
              </div>
              <div class="centerBox">
                  <div style="margin: 10px 0;">备注说明</div>
                  <div>
                          <a-textarea v-model="detailData.BaseInformation.remark" placeholder="请输入提示内容" disabled
                          :auto-size="{ minRows: 2, maxRows: 5 }" style="width:50%;" />
                  </div>
                  <div style="margin: 10px 0;">申请记录信息说明</div>
                  <div>
                          <a-textarea v-model="detailData.BaseInformation.tips" placeholder="请输入"  disabled
                          :auto-size="{ minRows: 2, maxRows: 5 }" style="width:50%;" />
                  </div>
              </div>
         </div>
        <!-- 图片文件 -->
        <div class="box">
          <div class="title">
            <span>附件管理<span style="font-weight: 400;"> （除发票以外的凭证附件）</span></span>
          </div>
          <div class="contentBox">
            <div class="left">
              <div style="margin-bottom: 10px">图片:</div>
              <div
                class="view_path_img"
                v-for="(item, index) in detailData.certificate"
                :key="index"
                style="display: flex; justify-content: space-between"
              >
                <div class="view_path_img_margin" ></div>
                <div class="view_path_img_center" >
                  <img :src="item.preUrl" @click="show_img(index, detailData.certificate)" />
                </div>
              </div>
              <preview ref="preview" />
            </div>
            <div class="right">
              <div style="margin-bottom: 10px">文件:</div>
              <div
                class="view_path"
                @click="previewFile(item)"
                v-for="(item, index) in detailData.appendix"
                :key="index"
              >
                {{ item.name }}
              </div>
            </div>
            
          </div>
        </div>
        <!-- 申请人账户信息 -->
        <div class="box">
          <div class="title">
            <span>申请人/账户信息</span>
          </div>
          <div class="centerBox">
            <div style="padding: 10px 0; font-weight: 700">报销账户</div>
            <!-- 循环账户 -->
            <div>
              <div>
                <img src="" alt="" />
                <span style="padding: 10px; font-weight: 700">{{
                  detailData.BaseInformation.account_information.apply
                }}</span>
              </div>
              <div>
                <span style="padding: 15px">{{
                  detailData.BaseInformation.account_information.reimbursement_account.accountTypeIdx
                }}</span>
                <span style="padding: 15px">{{
                  detailData.BaseInformation.account_information.reimbursement_account.accountNum
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 审批信息 -->
        <div class="examineDetail">
          <div class="title">
            <span>审批信息</span>
          </div>
          <div class="content">
            <auditModel :type="type" ref="auditModel"></auditModel>
          </div>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" type="primary" @click="onClose"> 导出数据 </a-button>
      </div>
    </a-drawer>
    <!-- 发票上传与预览 -->
    <a-modal class="gufiiguy" title="文件管理" :visible="fileVisible" @cancel="closeRecords" width="40%">
      <template slot="footer">
        <a-button key="back" @click="fileVisible = false"> 取消 </a-button>
      </template>
      <div class="containerBottom" style="margin-bottom: 40px">
        <!-- <div class="left">
          <div style="margin-bottom: 10px">图片预览:</div>
          <div
            class="view_path_img"
            style="display: flex; justify-content: space-between"
            v-for="(item, index) in vouchers"
            :key="index"
          >
            <div class="view_path_img_margin"></div>
            <div class="view_path_img_center" style="height: 60px; width: 60px; padding: 10px">
              <img :src="item.imgUrl" @click="show_img1(index, vouchers)" />
            </div>
          </div>
        </div> -->
        <div style="width: 80%;">
          <div style="margin-bottom: 10px">文件预览:</div>
          <div class="view_path" @click="previewFile(item)" v-for="(item, index) in appendix" :key="index">
            {{ item.name }}
          </div>
          <!-- <uploadFileCode :data="uploadData" /> -->
        </div>
      </div>
      <preview ref="preview1" />
    </a-modal>
  </div>
</template>

<script>
import preview from '@/components/module/prview'
import { download_file_java } from '@/utils/request'
import { resolveBlob } from '@/utils/index'
import { getPaymentDetail } from '@/api/financial'
import auditModel from '../../activiti/modules/audit.vue'
// import projecModelt from './projecModelt.vue'
// import expenses from './expenses.vue'
// import invoice from './invoice.vue'
// import relation from './relation.vue'
export default {
  components: {
    auditModel,
    // projecModelt,
    // expenses,
    // invoice,
    // relation,
    preview,
  },
  data() {
    return {
      preUrl: '',  
      appendix: [],
      vouchers: [],
      fileVisible: false,
      invoiceList: ['电子增值税普通发票', '电子增值税专用发票', '增值税普通发票', '增值税专用发票'],
      detailData: [],
      type: 1,
      purchaseData: [],
      approvalData: [],
      receiptData: [{}],
      //费用明细
      costDetail: [{}],
      accountData: [
        {
          name: 1,
        },
      ],
      applyData: [
        {
          name: 1,
        },
      ],
      options: [],
      detailVisible: false,
    }
  },
  methods: {
    closeRecords() {
      this.fileVisible = false
    },
    //文件展示
    downFile(index) {
    //   this.vouchers = []
    // console.log(process.env.VUE_APP_API_BASE_URL)
    //   var array = {
    //     imgUrl:  process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file' + '?bucketName=bill-img'+'&path=' + this.detailData.BaseInformation.bill_information[index].bill_img,
    //     // name: this.detailData.BaseInformation.bill_information[index].bill_img.fileName,
    //     // id: this.detailData.BaseInformation.bill_information[index].bill_img.id,
    //     // url: this.detailData.BaseInformation.bill_information[index].bill_img.path,
    //     url: this.detailData.BaseInformation.bill_information[index].bill_img,
    //   }
    //   this.vouchers.push(array)
      // this.detailData.BaseInformation.bill_information.forEach(item => {
      //   if(item.bill_attach) {
          
      //   }
      // })
      if(this.detailData.BaseInformation.bill_information[0].bill_attach) {
          this.appendix = []
          var data = {
            name: this.detailData.BaseInformation.bill_information[index].bill_attach.fileName,
            id: this.detailData.BaseInformation.bill_information[index].bill_attach.id,
            url: this.detailData.BaseInformation.bill_information[index].bill_attach.path,
            types: 'bill-appendix',
            preUrl: this.detailData.BaseInformation.bill_information[index].bill_attach.url,
          }
          this.appendix.push(data)

      }
     
      this.fileVisible = true
    },
    //预览图片
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    //预览图片
    show_img1(idx, imgs) {
      var as=[];
      imgs.forEach(element => {
        as.push( {preUrl:process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file' + '?bucketName=bill-img'+'&path=' + element.url})
      });
      console.log(imgs)
      var row = {
        index: idx,
        imgs: as,
      }
      this.$refs.preview1.show(row)
    },
    //文件预览
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },
    init(data) {
        console.log(data, 'data=================')
      getPaymentDetail(data.id).then((res) => {
        if (res.code == 200) {
          var array = []
          array.push(res.data.BaseInformation.information_relate)
          res.data.BaseInformation.information_relate = array
          this.detailData = res.data
          console.log( this.detailData.BaseInformation.isReceived, 'BaseInformation======================')
          this.detailVisible = true
          setTimeout(() => {
            this.$refs.auditModel.show({
              businessKey: data.id,
              procInstId: data.procInstId,
              procDefKey: data.procDefKey,
              recordNumber: 1,
            })
          }, 1000)
        }
      })
      //  const modal = modalMap[row.procDefKey]
    },
    onClose() {
      this.detailVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
.box {
  margin-top: 10px;
}
.centerBox {
  margin-top: 10px;
  padding: 10px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  border-radius: 5px;
}
.containerTop {
  font-weight: 700;
  /* float: left; */
  margin: 0;
  padding: 25px 0 10px 10px;
  color: black;
  font-size: 18px;
  border-bottom: 1px solid rgb(148, 147, 147);
}
.containerBottom {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}
.title {
  font-weight: 700;
  color: black;
}
.center {
  margin-top: 130px;
  margin-bottom: 50px;
  .centerInform {
    .content {
      padding: 20px;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
      border-radius: 5px;
      margin-top: 10px;
      .contentTop {
        display: flex;
        justify-content: space-between;
      }
      .left {
        height: 50px;
        width: 30%;
        background-color: #eef1f2;
        line-height: 50px;
        text-align: center;
      }
      .right {
        height: 50px;
        width: 70%;
        line-height: 50px;
        text-align: center;
      }
      .top,
      .bottom {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
      }
      .top {
        border-top: 1px solid rgb(230, 228, 228);
        background-color: #eef1f2;
      }
    }
  }
}
.costCenter {
  .detail {
    margin: 10px 5px;
    padding: 10px;
    .bottom {
      padding: 20px;
    }
  }
}
.receiptDetail {
  margin-top: 10px;
  .center {
    margin-top: 10px;
  }
}
.applyDetail {
  margin-top: 10px;
  .content {
    margin-top: 10px;
  }
}
.countDetail {
  margin-top: 10px;
  .content {
    padding: 10px;
  }
}
.examineDetail {
  margin-top: 10px;
  .content {
    margin-top: 10px;
    padding: 10px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    border-radius: 5px;
  }
}
.contentBox {
  margin-top: 10px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  border-radius: 5px;
  .right,
  .left {
    padding: 20px;
    width: 50%;
  }
}
 .expensesTitle {
    font-weight: 700;
    margin-left: 0px;
    margin-bottom: 10px;
    color: black;
    display: flex;
    justify-content: space-between;
    margin-right: 20px;
    }
    .travelBoxTop {
    border: 1px solid #dedfdf;
    height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}
 .travelContetTop {
            background-color: #EDF1F2 ;
            height: 51px;
            line-height: 50px;
            text-align: center;
            // box-sizing: border-box;

        }
 .borderStyle {
      border-left: 1px solid #dedfdf;
      border-right: 1px solid #dedfdf;
        }
 .borderBottom {
      border-bottom: 1px solid #dedfdf;
 }
.layoutbox {
        display: flex; 
        flex-direction: row; 
        flex-wrap: nowrap;
        border-Top: 1px solid #dedfdf;
        // box-sizing: border-box;

}
.travelContetBottom {
    padding: 10px;
    height: 50px;
    span {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
}
.travelBoxCenter {
    height: 153px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    // box-sizing: border-box;

}
.travelCenter {
    height: 50px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
   .contener {
       line-height: 49px;
       text-align: center;
       width: 18%;
       border-right: 1px solid #dedfdf;
       background-color: #EDF1F2
       
   }
   .contenerBox {
      width: 32%;
      border-right: 1px solid #dedfdf;

   }
   .contenerCenter {
      width: 40%;
      padding: 10px;
      border-right: 1px solid #dedfdf;
       
   }

}
</style>